import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import { Redirect } from 'react-router-dom';
import JobDetailView from '../components/JobDetailView.tsx';
import JobsService from '../services/JobsService.ts';

type Props = { match: { params: { id: string } } };

const JobDetailPage: React.FC<Props> = ({ match }) => {
  const jobId = match?.params?.id || null;
  const svc = JobsService.getInstance();
  const jobs = svc.getCurrentJobs();
  const activeSearchId = svc.getActiveSearchId();

  // If viewport is desktop/tablet, use split view by redirecting to Jobs with query param
  const isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
  if (!isMobile && jobId) {
    const params = new URLSearchParams({ jobId });
    return <Redirect to={`/app/jobs?${params.toString()}`} />;
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/jobs" text="Back" />
          </IonButtons>
          <IonTitle>Job Details</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <JobDetailView jobId={jobId} jobsCache={jobs} activeSearchId={activeSearchId} />
      </IonContent>
    </IonPage>
  );
};

export default JobDetailPage;
